import { Component, input } from '@angular/core';
import { NineSlicedSpriteComponent } from '@features/sprites/nine-sliced-sprite/nine-sliced-sprite.component';

@Component({
  selector: 'wk8-conveyor-belt',
  imports: [NineSlicedSpriteComponent],
  templateUrl: './wk8-conveyor-belt.component.html',
  styleUrl: './wk8-conveyor-belt.component.css',
})
export class Wk8ConveyorBeltComponent {
  zIndex = input<number | undefined>(undefined);
}
